import { ApiRoutingUtils } from '@/Routing';
import { UserProductModel } from '@/Models';
import { rest } from '@/Api/Rest';
import { LogisticProduct } from '@/Models/UserProducts/LogisticProduct';
import { GetUserProductTypesRequest } from './Requests/GetUserProductTypesRequest';
import { GetUserProductTypesResponse } from './Responses/GetUserProductTypesResponse';
import { CreateUserProductRequest } from './Requests/CreateUserProductRequest';
import { CreateUserProductResponse } from './Responses/CreateUserProductResponse';
import { UpdateUserProductRequest } from './Requests/UpdateUserProductRequest';
import { UpdateUserProductResponse } from './Responses/UpdateUserProductResponse';

const url = ApiRoutingUtils.createUrl('user-products');

async function getProducts(): Promise<UserProductModel[]> {
  return rest.get(url);
}

async function createProduct(request: CreateUserProductRequest): Promise<CreateUserProductResponse> {
  return rest.post(url, request);
}

async function updateProduct(request: UpdateUserProductRequest): Promise<UpdateUserProductResponse> {
  return rest.put(url, request);
}

async function deleteProduct(id: number): Promise<number> {
  return rest.delete(`${url}/${id}`, null);
}

async function getLogisticProducts(): Promise<LogisticProduct[]> {
  return rest.get(`${url}/logistic-products`);
}

async function getUserProductTypes(request: GetUserProductTypesRequest): Promise<GetUserProductTypesResponse> {
  return rest.get(`${url}/user-product-types`, request);
}

export const UserProductsApi = {
  getProducts,
  createProduct,
  updateProduct,
  deleteProduct,
  getLogisticProducts,
  getUserProductTypes,
};
